import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=f46e48ba&scoped=true"
import script from "./detail.js?vue&type=script&lang=js&external"
export * from "./detail.js?vue&type=script&lang=js&external"
import style0 from "./detail.vue?vue&type=style&index=0&id=f46e48ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46e48ba",
  null
  
)

export default component.exports